export async function fetchImages() {
  const response = await fetch(`https://api.thecatapi.com/v1/images/search`, {
    mode: "cors",
  });
  var data = await response.json();
  console.log(data);
  return data;
}
// catService.js
export async function fetchCatImages() {
  const numberOfRequests = 10; // 30回実行する
  const fetchRequests = []; // Promise のリストを作成

  // 30回 `fetch` を実行し、Promise のリストを作成
  for (let i = 0; i < numberOfRequests; i++) {
    const fetchRequest = fetch(`https://api.thecatapi.com/v1/images/search`, {
      mode: "cors",
    });
    fetchRequests.push(fetchRequest); // Promise のリストに追加
  }

  // すべての `fetch` が完了するのを待つ
  const responses = await Promise.all(fetchRequests);

  // すべてのレスポンスを JSON に変換
  const dataPromises = responses.map((response) => response.json());

  // すべてのデータが取得できるのを待つ
  const allData = await Promise.all(dataPromises);

  return allData; // すべてのデータを返す
}
